<template lang="pug">
  .vue-container(:style="containerStyle")
    .vue-inner
      .vue-content
        .vue-title(:style="textColorStyle")
          template(v-if="title")
            span.vue-title_text(v-text="title")
          template(v-else)
            span.vue-discount_off(v-text="discount")
            | &nbsp;OFF Coupon
        .vue-tagline(:style="textColorStyle", v-text="tagline")
      .vue-divider(:style="backgroundColorStyle")
      .vue-content
        .vue-promotion_label(:style="textColorStyle") COUPON CODE
        .vue-code
          input.vue-code_field(ref="codeField", :id="'vue-code' + _uid", :style="backgroundColorStyle", :value="code", readonly, @focus="selectCode", @click="selectCode")
          button.vue-copy_btn(type="button", :style="darkenBackgroundColorStyle", :data-clipboard-target="'#vue-code' + _uid") Copy

</template>

<script>
import colorUtil from '../../util/color';

export default {
  props: {
    // title が指定されれば discount よりも優先
    title: String,
    // 割引値 % or $
    discount: String,
    // クーポンの概要
    tagline: String,
    // クーポンコード
    code: String,
    // テーマカラー
    color: {
      type: String,
      default: '#2775A0'  // Shop base color
    }
  },

  computed: {
    darkenColor() {
      return colorUtil.darken(this.color, 10);
    },

    /*
      Styles
      */
    containerStyle() {
      return {
        background: `repeating-linear-gradient(135deg, ${this.color} 0%, ${
          this.color
        } 2%, ${this.darkenColor} 2%, ${this.darkenColor} 4%)`
      };
    },
    backgroundColorStyle() {
      return { backgroundColor: this.color };
    },
    darkenBackgroundColorStyle() {
      return { backgroundColor: this.darkenColor };
    },
    textColorStyle() {
      return { color: this.color };
    }
  },

  methods: {
    selectCode() {
      this.$refs['codeField'].select();
    },

    // クリップボードコピー機能を有効にする
    initializeClipboardCopy() {
      const clipboard = new window.Clipboard('.vue-copy_btn');
      const showClipedTooltip = function(target, msg) {
        $(target)
          .attr('data-tooltip', msg)
          .addClass('c-tooltip c-tooltip--show');
        setTimeout(
          () => $(target).removeClass('c-tooltip c-tooltip--show'),
          1500
        );
      };
      clipboard.on('success', e => showClipedTooltip(e.trigger, 'Copied!'));
      clipboard.on('error', function(e) {
        let msg;
        if (/iPhone|iPad/i.test(window.navigator.userAgent)) {
          msg = 'No support :(';
        } else if (/Mac/i.test(window.navigator.userAgent)) {
          msg = 'Press ⌘-C to copy';
        } else {
          msg = 'Press Ctrl-C to copy';
        }
        showClipedTooltip(e.trigger, msg);
      });
    }
  },

  mounted() {
    this.initializeClipboardCopy();
  }
};
</script>

<style scoped>
.vue-container {
  container-type: inline-size;
  container-name: coupon-code-compornent;
  padding: 15px;
}
.vue-inner {
  display: flex;
  justify-content: space-around;
  background: #fff;
  padding: 35px 20px;
}
.vue-content {
  flex: 1;
  padding: 10px 20px;
  align-self: center;
  text-align: center;
}
.vue-divider {
  width: 1px;
  margin: 0 10px;
}
.vue-title {
  font-size: 3.6rem;
  font-weight: bold;
}
.vue-discount_off {
  font-size: 4.8rem;
}
.vue-title_text {
  font-size: 3.6rem;
}
.vue-tagline {
  font-size: 2.4rem;
}
.vue-promotion_label {
  font-size: 2.4rem;
}
.vue-code {
  display: flex;
}
.vue-code_field {
  appearance: none;
  font-size: 3.6rem;
  font-weight: bold;
  color: #fff;
  padding: 5px;
  margin: 0;
  border: none;
  border-radius: 0;
  outline: none;
  text-align: center;
  width: 100%;
}
.vue-copy_btn {
  appearance: none;
  user-select: none;
  touch-action: manipulation;
  outline: 0;
  -webkit-tap-highlight-color: transparent;
  padding: 5px 20px;
  font-size: 2.4rem;
  color: #fff;
  border: none;
  border-radius: 0;
  white-space: nowrap;
}
@container coupon-code-compornent (width <= 768px) {
  .vue-inner {
    flex-direction: column;
    padding: 20px;
  }
  .vue-content {
    padding: 0;
  }
  .vue-content:first-child {
    padding-bottom: 20px;
  }
  .vue-divider {
    display: none;
  }
  .vue-title {
    font-size: 2.4rem;
  }
  .vue-discount_off {
    font-size: 3.2rem;
  }
  .vue-title_text {
    font-size: 2.4rem;
  }
  .vue-tagline {
    font-size: 1.6rem;
  }
  .vue-promotion_label {
    font-size: 1.4rem;
  }
  .vue-code_field {
    font-size: 2.4rem;
  }
  .vue-copy_btn {
    font-size: 1.4rem;
  }
}
</style>
